<template>
  <div class="page">
    <div
      class="page-container"
      v-if="authorInfo"
      :class="{ 'page-container--fast-news': isFastNews }"
      ref="container"
    >
      <div
        style="
          height: 1px;
          position: fixed;
          width: 100%;
          transform: scaleY(0.5);
        "
        class="L2"
      ></div>
      <div class="title S14 T1">{{ dianJinInfo.title }}</div>
      <div class="head">
        <div class="avatarWrap marginL30" @click="goManager()">
          <img :src="authorInfo.headPic" class="avatar" alt />
          <img src="../../static/ic_v_log.png" class="log" alt />
        </div>
        <div class="row1" @click="goManager()">
          <div class="S8 T1">{{ authorInfo.name }}</div>
          <div class="S4 T3 desc">{{ getDesc }}</div>
        </div>
        <div
          class="follow S5 C5"
          :class="authorInfo.isFollowed === 1 ? 'followed' : ''"
          @click="follow()"
        >
          <span>{{ authorInfo.isFollowed === 1 ? '已关注' : '+关注' }}</span>
        </div>
      </div>
      <div
        style="height: 1px; width: 100%; transform: scaleY(0.5)"
        class="L2 headDiv"
      ></div>
      <!-- 详情内容 -->
      <div
        class="ariticle-wrap S10 T1"
        :class="{ 'ariticle-hidden': !isPermission }"
        v-if="type === 4"
      >
        <div class="ariticle-content s10 t1" v-html="dianJinInfo.content"></div>
        <div class="article-cover B_C1" v-if="!isPermission">
          <div class="subscribe-font S4 T1">订阅后阅读全文</div>
          <div class="arrow"></div>
          <div class="subscribe-btn S8 T5" @click="goBuy()">
            <div class="lock-icon"></div>
            <div>立即订阅</div>
          </div>
        </div>
      </div>
      <div v-if="type === 2">
        <AudioPlay
          :audioLength="playData.duration"
          :audioFileUrl="playData.playURL"
          :isPermission="isPermission"
          :isLogin="isLogin"
          @childGoBuy="goBuy()"
        ></AudioPlay>
      </div>

      <div
        class="video-wrap"
        v-if="type === 1 && playData.playURL"
        :style="videoHeightStyle"
      >
        <div
          ref="videoMask"
          style="position: relative"
          :style="videoHeightStyle"
        >
          <VueAliplayer
            class="video"
            :preload="false"
            :autoplay="isPermission && isLogin ? true : false"
            :playsinline="false"
            :source="playData.playURL"
            :skinLayout="skinLayout"
            :height="videoHeight"
            :video-height="videoHeight"
            style="width: 100%"
            @play="startPlay"
          />
          <VideoMask
            v-if="isMaskShowFix"
            style="
              position: absolute;
              height: 100%;
              width: 100%;
              top: 0;
              left: 0;
            "
            :style="videoHeightStyle"
          />
        </div>
        <div
          class="cover-wrap"
          :class="{ 'no-login-wrap': !isLogin }"
          v-if="!isPermission || !isLogin"
        >
          <div class="lock-icon" v-if="isLogin"></div>
          <div class="subscribe-btn S8 T5" @click="goBuy()">
            {{ isLogin ? '立即订阅' : '立即登录' }}
          </div>
          <div class="subscribe-font S4 T1">
            {{ isLogin ? '订阅后点击播放视频' : '登录后可收看完整视频' }}
          </div>
        </div>
      </div>
      <div class="risk-tip T3 S3">
        风险提示：本内容仅供投资参考，不作为投资建议，股市有风险，投资需谨慎。
      </div>
      <div v-if="stocks.length > 0" class="space"></div>
      <Stock :stockList="stocks" :stockListCode="stockListCode"></Stock>
      <div class="space"></div>

      <template v-if="!isFastNews">
        <ViewPoint :articleList="RelatesData" @emitId="handleId"></ViewPoint>
        <div class="space"></div>
        <Comment
          v-if="commentsInfo"
          :commentsInfo="commentsInfo"
          :showInput="true"
          :hasPermission="isPermission"
          :id="id"
          currentIndex="1"
          :showPupInput="!showCommentDetail"
          :isFavored="dianJinInfo.isFavored"
          @onReplyEvent="onReplyEvent"
        />

        <div
          class="comment-mask B1"
          v-if="showCommentDetail"
          @touchmove.stop="onCloseEvent"
          @click.stop="onCloseEvent"
        ></div>
        <div
          class="comment-container B1"
          :style="[commentStyle]"
          v-if="showCommentDetail"
          @touchmove.stop="onScrollEvent"
        >
          <CommentDetail
            :comment="currComment"
            :isPermission="isPermission"
            @onCloseEvent="onCloseEvent"
          />
        </div>

        <div style="height: 300px" v-if="showCommentDetail"></div>
      </template>
    </div>
  </div>
</template>

<script>
import util from '@/util/util'
import { mapActions } from 'vuex'
import ViewPoint from '@/components/ViewPoint'
import AudioPlay from '@/components/AudioPlay'
import Stock from '@/components/Stock'
import Comment from '@/views/comment/Comment'
import appInfo from '@/assets/js/appInfo.js'
import CommentDetail from '@/views/comment/CommentDetail'
import {
  requestappInfo,
  getStatusHeight,
  titleStatusBarHeight,
  isAndroid
} from '@/api/appInfo'
import VueAliplayer from '@/views/test/VueAliplayer'
import http from '@/api/http'
import { checkPermission, hasPermission } from '@/api/permission'
import VideoMask from '@/views/video/VideoMask'
import dayjs from 'dayjs'
import appInfoAll from '@/assets/js/appInfo.js'
import ym from '@/assets/js/ym.js'
import config from '@/api/config'
import { Log, openurl } from '@em/ym'

export default {
  name: 'Detail',
  components: {
    VideoMask,
    AudioPlay,
    ViewPoint,
    Stock,
    Comment,
    CommentDetail,
    VueAliplayer
  },
  data() {
    return {
      isLogin: '',
      id: appInfo.getParam('id'),
      authorInfo: '',
      dianJinInfo: '',
      commentsInfo: '',
      stocks: '',
      stockListCode: '',
      RelatesData: '',
      playData: '',
      weChatAppId: '31',
      weChatAppKey: null,
      // isPermission: false,
      currComment: {},
      videoHeight: util.getVideoHeight() + 'px',
      isPlayed: false,
      skinLayout: [
        {
          name: 'bigPlayButton',
          align: 'cc'
        },
        {
          name: 'H5Loading',
          align: 'cc'
        },
        {
          name: 'errorDisplay',
          align: 'tlabs',
          x: 0,
          y: 0
        },
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0,
          children: [
            {
              name: 'progress',
              align: 'blabs',
              x: 0,
              y: 44
            },
            {
              name: 'playButton',
              align: 'tl',
              x: 15,
              y: 12
            },
            {
              name: 'timeDisplay',
              align: 'tl',
              x: 10,
              y: 7
            },
            {
              name: 'fullScreenButton',
              align: 'tr',
              x: 10,
              y: 12
            }
          ]
        }
      ]
    }
  },
  mounted() {
    appInfoAll.getClientInfo(() => (this.isLogin = appInfoAll.isLogin))
    requestappInfo()
    this.$onResume(() => {
      console.log('onResume')
      requestappInfo()
      // if (isAndroid()) {
      appInfoAll.getClientInfo(() => (this.isLogin = appInfoAll.isLogin))
      // } else {
      //   setTimeout(() => {
      //     appInfoAll.getClientInfo(() => (this.isLogin = appInfoAll.isLogin))
      //   }, 2000)
      // }

      setTimeout(() => {
        checkPermission(this.dianJinInfo.productId)
      }, 5000)
    })
    this.init()
    window.onscroll = this.updateMaskPosition
    let lastOrientationChangeTime
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      () => {
        console.log('onorientationchange', window.orientation)
        setTimeout(() => {
          this.updateMaskPosition()
        }, 500)
        lastOrientationChangeTime = new Date().getTime()
      },
      false
    )
    const innerH = window.innerHeight
    window.addEventListener('resize', () => {
      console.log('resize', window.innerWidth, window.innerHeight)
      setTimeout(() => {
        if (new Date().getTime() - lastOrientationChangeTime < 300) return
        if (window.orientation === 180 || window.orientation === 0) {
          console.log('scroll', window.innerWidth, window.innerHeight)
          window.scrollBy(0, window.innerHeight < innerH ? 300 : -300)
        }
      }, 100)
    })
    Log.pageView({
      pageId: 'Html:YktAppDianJin'
    })
  },
  watch: {
    showCommentDetail(val) {
      this.bodyElm = this.bodyElm || document.body
      if (val) {
        this.bodyElm.style.overflow = 'hidden'
      } else {
        this.bodyElm.style.overflow = 'auto'
      }
      setTimeout(() => {
        window.scrollBy(0, !val ? -300 : 300)
      }, 100)
    }
  },
  computed: {
    dayjs,
    videoHeightStyle() {
      console.log(util.getVideoHeight(), 'videoheight---')
      return {
        height: util.getVideoHeight() + 'px'
      }
    },
    isFree() {
      return this.dianJinInfo.isFree
    },
    resourceIdentity() {
      return this.dianJinInfo.resourceIdentity
    },
    type() {
      // type 1 视频  2 音频   4 图文
      return this.dianJinInfo.type
    },
    showCommentDetail() {
      return Object.keys(this.currComment).length > 0
    },
    getDesc() {
      if (!this.authorInfo) {
        return ''
      }
      let authInfo = this.authorInfo
      let desc = ''
      desc += authInfo.typeName
      if (authInfo.authorCompany && authInfo.authorCompany.length > 0) {
        desc += ' | ' + authInfo.authorCompany
      }
      return this.dianJinInfo.publishTimeDesc + ' · ' + desc
    },

    isPermission() {
      return this.dianJinInfo.isAvailable
    },
    /**
     * 快讯需要隐藏相关观点和评论
     */
    isFastNews() {
      return this.dianJinInfo.channel === 9
    },

    statusPading() {
      return {
        marginTop: getStatusHeight() + 'px'
      }
    },
    commentStyle() {
      const statusHeight = getStatusHeight()
      const commentHeight =
        window.screen.height - util.getVideoHeight() - statusHeight + 'px'
      return {
        bottom: '0px',
        height: commentHeight
      }
    },

    productId() {
      return `${this.dianJinInfo.productId}`
    },
    isMaskShowFix() {
      return !isAndroid() && this.isPlayed && !this.isFree
    }
  },
  methods: {
    ...mapActions('follow', ['requestfollow']),
    ...mapActions('appInfo', ['requestappInfo']),
    hasPermission,
    init() {
      this.setWeChatAppInfo()
      this.requestviewPointFun()
        .then(() => {
          if (this.type < 4) {
            this.ResourceFun()
          }
        })
        .then(() => {
          this.showMenuItems()
        })
      this.requestRelatesFun()
    },
    async requestviewPointFun() {
      let { detail } = await http.post('/DianJin/api/detail', {
        id: this.id
      })
      this.authorInfo = detail.authorInfo
      this.dianJinInfo = detail.dianJinInfo
      this.commentsInfo = detail.commentsInfo
      this.stocks = detail.stocks
      checkPermission(detail.dianJinInfo.productId)

      if (window.goods) {
        window.goods.showVideoMask(!this.isFree)
      }

      let stockListCode = []
      detail.stocks.forEach(item => {
        stockListCode.push(item.stockId)
      })
      this.stockListCode = stockListCode
      setTimeout(() => {
        this.handleContent()
      }, 100)
    },

    handleContent() {
      window.HANDLE_HREF = url => {
        if (!url) return '###'
        Log.click({
          eventId: 'Click',
          eventData: {
            url
          }
        })
        openurl(url)
      }
      const dom = document.querySelectorAll('.ariticle-content a')
      if (!dom.length) return
      Array.from(dom).forEach(item => {
        const url = item.href
        if (/^http]/.test(url)) {
          item.href = `javascript:HANDLE_HREF('${url}')`
        }
      })
    },
    async requestRelatesFun() {
      let { detail } = await http.post('/DianJin/Api/Relates', {
        id: this.id
      })
      this.RelatesData = detail
    },
    async ResourceFun() {
      let { detail } = await http.post('/Resource/Api/PlayInfo', {
        resourceIdentity: this.resourceIdentity
      })
      this.playData = detail
    },
    handleId(id) {
      this.id = String(id)
      this.init()
    },
    onReplyEvent(item) {
      console.log(item)
      this.currComment = item
    },
    onCloseEvent() {
      this.currComment = ''
    },
    goManager() {
      util.go('ycstock://managerDetail?managerId=' + this.authorInfo.authorId)
    },
    follow() {
      // appInfoAll.getClientInfo(() => {
      this.isLogin = appInfoAll.isLogin
      if (!this.isLogin) {
        util.go('ycstock://login')
        return
      }
      this.authorInfo.isFollowed = this.authorInfo.isFollowed ^ 1
      this.requestfollow({
        authorid: this.authorInfo.authorId,
        follow: this.authorInfo.isFollowed
      })
      // })
    },
    goBuy() {
      // appInfoAll.getClientInfo(() => {
      this.isLogin = appInfoAll.isLogin
      if (!this.isLogin) {
        util.go('ycstock://login')
        return
      }

      if (!this.dianJinInfo.payUrl) {
        this.$toast('支付地址不存在')
        return
      }
      let uri = 'ycstock://web?url=' + escape(this.dianJinInfo.payUrl)
      util.go(uri)
      // })
    },
    onScrollEvent() {},
    startPlay() {
      this.isPlayed = true
      this.updateMaskPosition()
    },
    updateMaskPosition() {
      let mask = this.$refs.videoMask
      if (!mask) return
      let rect = mask.getBoundingClientRect()
      if (window.goods) {
        console.log(window.orientation)
        if (window.orientation === 180 || window.orientation === 0) {
          let devicePixelRatio = window.devicePixelRatio
          console.log(
            'updateMaskPosition',
            rect.x * devicePixelRatio,
            rect.y * devicePixelRatio + titleStatusBarHeight(),
            rect.width * devicePixelRatio,
            rect.height * devicePixelRatio
          )
          window.goods.updateVideoMask(
            this.isPlayed && !this.isFree,
            rect.x * devicePixelRatio,
            rect.y * devicePixelRatio + titleStatusBarHeight(),
            rect.width * devicePixelRatio,
            rect.height * devicePixelRatio
          )
        } else if (window.orientation === 90 || window.orientation === -90) {
          //横屏交给native全屏
          console.log('updateMaskPosition', 0, 0, 0, 0)
          window.goods.updateVideoMask(
            this.isPlayed && !this.isFree,
            0,
            0,
            0,
            0
          )
        }
      }
    },
    async setWeChatAppInfo() {
      if (!this.weChatAppKey) {
        let { detail } = await http.get('/account/WeChat/GetWeChatAppId', {
          AppId: this.weChatAppId
        })
        this.weChatAppKey = detail
        console.log('this.weChatAppKey:')
        console.log(this.weChatAppKey)
      }
    },
    showMenuItems() {
      this.setWeChatAppInfo()
      if (ym.isSharePopEnable()) {
        ym.showMenuItems({
          menuItems: [
            {
              callback: () => {
                ym.showSharePop({
                  title: this.dianJinInfo.title,
                  content: '有看投',
                  url:
                    config.h5Url +
                    '/dianjin/' +
                    this.dianJinInfo.id +
                    '?appId=' +
                    this.weChatAppId +
                    '&wxAppId=' +
                    this.weChatAppKey
                })
              },
              icon: 'https://appstatic.emoney.cn/images/20210419/9365ccedef860827d27e3ac32c638071.png'
            }
          ]
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.page-container {
  padding-bottom: 138px;
  position: relative;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  
  &--fast-news {
    padding-bottom: 0;
  }
}
.risk-tip {
  padding: 20px 30px;
}

.comment-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  /*-webkit-overflow-scroll:touch;*/
  z-index: 99;
}

.comment-mask {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000;
  opacity: 0.5;
}

.video-wrap {
  position: relative;
  margin: 50px 30px;

  .cover-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    // border-radius: 10px;
    z-index: 1000;
    text-align: center;
    background-color: rgba($color: #deecf7, $alpha: 0.9);
    &.no-login-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .subscribe-btn {
        background-color: #046bcc;
      }
    }

    .lock-icon {
      width: 92px;
      height: 92px;
      background: url('./images/video-lock.png') no-repeat;
      background-size: cover;
      margin: 78px auto 0;
    }

    .subscribe-btn {
      width: 200px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px auto;
      background-color: #ddbc65;
      border-radius: 10px;
      font-size: 28px;
    }
  }
}

.space {
  height: 18px;
  background-color: #efeff4;
}

.ariticle-wrap {
  padding: 0 30px 50px 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  .ariticle-content {
    // text-indent: 2em;
    overflow: hidden;
    text-align: left;
    line-height: 64px;
    ::v-deep img {
      width: 100% !important;
      height: 100% !important;
      margin: 20px 0;
    }
  }
}

.ariticle-hidden {
  position: relative;
  //height: 660px;
  height: 380px;
  overflow: hidden;

  .subscribe-btn {
    width: 300px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    background-color: #ddbc65;
    border-radius: 10px;

    .lock-icon {
      width: 30px;
      height: 36px;
      background: url('./images/lock.png') no-repeat;
      background-size: cover;
      margin-right: 14px;
    }
  }

  .subscribe-font {
    margin-top: 116px;
  }

  .arrow {
    width: 20px;
    height: 12px;
    background: url('./images/arrow.png') no-repeat;
    background-size: cover;
    margin: 20px auto 0;
  }

  .article-cover {
    width: 100%;
    height: 380px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    background: #fff;
  }
}

.title {
  padding: 44px 30px 30px;
  font-weight: bold;
}

.head {
  margin-top: 20px;
  align-items: center;
  display: flex;
  flex-direction: row;

  .row1 {
    margin-left: 30px;
  }

  .avatarWrap {
    height: 70px;
    width: 70px;
    position: relative;
  }

  .avatar {
    border-radius: 35px;
    height: 70px;
    width: 70px;
  }

  .log {
    position: absolute;
    width: 28px;
    height: 28px;
    right: 0;
    bottom: 0;
  }

  .marginL30 {
    margin-left: 30px;
  }

  .follow {
    display: flex;
    justify-content: center;
    right: 30px;
    width: 118px;
    position: absolute;
    height: 52px;
    border-radius: 5px;
    border-width: 2px;
    text-align: center;
    border-style: solid;
    border-color: #046bcc;
    align-items: center;
  }

  .followed {
    border-color: #858585 !important;
    color: #858585 !important;
  }
}

.comment-bg {
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.headDiv {
  margin-top: 48px;
  margin-bottom: 48px;
}

.desc {
  margin-right: 156px;
}
</style>
